// extracted by mini-css-extract-plugin
module.exports = {"container":"network-panel_container__ou7yu"};